export default "__VITE_ASSET__CaMnZxG1__"